<template>
  <div>
    <div
      v-if="isPreloader"
      class="configurator-skeleton"
    >
      <div class="configurator-skeleton__fields">
        <a-skeleton
          v-for="item in [1, 2, 3, 4, 5, 6, 7]"
          :key="item"
          active
          :avatar="{
            shape: 'circle'
          }"
          :paragraph="{
            rows: 1
          }"
        ></a-skeleton>
      </div>

      <div class="configurator-skeleton__summ">
        <a-skeleton
          active
          :paragraph="{
            rows: 2
          }"
        ></a-skeleton>
        <a-skeleton
          active
          :paragraph="{
            rows: 2
          }"
        ></a-skeleton>
      </div>
    </div>

    <iframe
      :style="{opacity: isPreloader ? 0 : 1, height: isPreloader ? 0 : `${height}px`}"
      src="/custom_calc/?new-design"
      width="100%"
      frameborder="no"
      seamless
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'DedicatedIframeConfigurator',
  data() {
    return {
      isInited: false,
      height: 0
    }
  },
  computed: {
    isPreloader() {
      return !(this.isInited && this.height > 500)
    }
  },
  destroyed() {
    window.removeEventListener('message', this.iframeLoadHandler, false)
  },
  mounted() {
    window.addEventListener('message', this.iframeLoadHandler, false)
  },
  methods: {
    iframeLoadHandler(evt) {
      if (!evt.source.frameElement) return

      try {
        if (evt.data === 'seido_configurator_inited') {
          this.isInited = true
        } else {
          const data = JSON.parse(evt.data)

          if (data.height) {
            this.height = data.height + 30
          }
        }
      } catch (err) {
        // eslint-disable-next-line
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
.configurator-skeleton__fields {
  .ant-skeleton-header {
    padding: 0 !important;
    position: relative;

    &:after {
      content: '';
      z-index: -10;
      position: absolute;
      top: 0;
      left: 12px;
      background: #D9D9D6;
      width: 1px;
      height: 100%;
    }

  }

  .ant-skeleton-avatar {
    width: 24px;
    height: 24px;
    margin-right: 95px;
    padding: 0 !important;

    @media (max-width: 790px) {
      margin-right: 10px;
    }
  }

  .ant-skeleton-title {
    height: 20px;
    width: 170px !important;
    margin: 0 !important;
  }

  .ant-skeleton-paragraph {
    margin-top: 2px !important;
    margin-bottom: 16px;
  }

  .ant-skeleton-paragraph li {
    height: 38px;
    width: 340px;

    @media (max-width: 790px) {
      width: 500px;
    }

    @media (max-width: $breakpoint-sm) {
      width: 100%;
    }
  }

  .ant-skeleton {
    .ant-skeleton-avatar {
      margin-top: 29px;
    }

    &:last-of-type .ant-skeleton-header:after {
      height: 50%;
    }

    &:first-of-type .ant-skeleton-header:after {
      height: 50%;
      top: 50%;
    }
  }
}

.configurator-skeleton__summ {
  overflow: hidden;
  margin-top: 42px;
  width: 100%;
  border-top: 1px solid #E8E8E8;
  padding-left: 477px;

  @media (max-width: 790px) {
    padding-left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .ant-skeleton {
    @media (max-width: 790px) {
      width: auto;
    }

    .ant-skeleton-content {
      @media (max-width: 790px) {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }

    .ant-skeleton-paragraph {
      margin: 0 !important;

      @media (max-width: 790px) {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: auto;
      }
    }

    .ant-skeleton-title, .ant-skeleton-paragraph li {
      width: 339px !important;

      @media (max-width: 790px) {
        width: 238px !important;
      }
    }

    .ant-skeleton-header {
      padding: 0 !important;
    }

    &:first-of-type {
      .ant-skeleton-title {
        height: 40px;
        margin: 16px 0 12px !important;
      }

      .ant-skeleton-paragraph li {
        height: 22px !important;
        margin-top: 2px !important;

        @media (max-width: 790px) {
          height: 19px !important;
        }
      }
    }

    &:last-of-type {
      .ant-skeleton-title {
        height: 33px;
        margin: 8px 0 4px !important;
      }

      .ant-skeleton-paragraph {
        li {
          &:first-of-type {
            height: 17px !important;

            @media (max-width: 790px) {
              height: 31px !important;
            }
          }

          &:last-of-type {
            margin-top: 24px !important;
            height: 48px !important;
          }
        }
      }
    }
  }
}
</style>